import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './About.css';

const About = () => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  const [stats, setStats] = useState([
    { value: 0, target: 30, suffix: '+', label: 'Years in Software' },
    { value: 0, target: 4, suffix: '', label: 'Published Mobile Apps' },
    { value: 0, target: 2, suffix: '', label: 'Native App Platforms' }
  ]);

  useEffect(() => {
    if (inView) {
      const interval = setInterval(() => {
        setStats(prevStats => 
          prevStats.map(stat => ({
            ...stat,
            value: stat.value < stat.target ? stat.value + 1 : stat.target
          }))
        );
      }, 50);

      return () => clearInterval(interval);
    }
  }, [inView]);

  return (
    <section id="about" className="about" ref={ref}>
      <div className="container">
        <motion.div 
          className="about-content"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6 }}
        >
          <motion.div 
            className="about-text"
            initial={{ opacity: 0, x: -50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h2>About Top Most Systems</h2>
            <p>
              <strong>Top Most Systems</strong> is a Montreal software company that builds{' '}
              <strong>business websites</strong>, <strong>mobile apps</strong>, and lasting fixes for systems already in production.
            </p>
            <p>
              We specialize in <strong>company websites</strong>, <strong>legacy system maintenance</strong>,{' '}
              <strong>mobile app recovery</strong>, and <strong>Android-to-iOS (Objective-C) conversions</strong>
              {' '}— especially projects that are hard to maintain, partially broken, or need experienced technical guidance.
              A recent web project is the <a href="https://www.groupednk.ca/" target="_blank" rel="noopener noreferrer">Groupe DNK</a> engineering site.
            </p>
            <p>
              We bring <strong>30+ years</strong> in software to inherited code, App Store issues, and systems other teams hesitate to touch.
            </p>
            <p>
              Clients typically start with <strong>short-term, clearly scoped help</strong> — a{' '}
              <strong>quick technical assessment</strong> to agree the safest next steps.
            </p>
            <motion.div 
              className="about-stats"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              {stats.map((stat, index) => (
                <motion.div 
                  key={index}
                  className="stat"
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={inView ? { opacity: 1, scale: 1 } : {}}
                  transition={{ 
                    duration: 0.5, 
                    delay: 0.6 + index * 0.2,
                    type: "spring",
                    stiffness: 100
                  }}
                >
                  <h3>{stat.value}{stat.suffix}</h3>
                  <p>{stat.label}</p>
                </motion.div>
              ))}
            </motion.div>
          </motion.div>

          <motion.div 
            className="about-image"
            initial={{ opacity: 0, x: 50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <motion.div 
              className="image-placeholder"
              whileHover={{ 
                scale: 1.05,
                rotate: 5,
                transition: { duration: 0.3 }
              }}
            >
              <i className="fas fa-building"></i>
              <span>Top Most Systems</span>
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;


